<template>
  <div>
    <v-row
      class="mt-0"
      no-gutters
    >
      <v-spacer />
    </v-row>
    <v-card-widget title="Dashboard">
      <div slot="widget-content">
        <app-timeline :itens="timelineItens" />
      </div>
    </v-card-widget>
  </div>
</template>

<script>
import VCardWidget from '@/components/VWidget';
import AppTimeline from '@/components/core/AppTimeline';

export default {
  name: 'DashboardPerfil',

  components: { VCardWidget, AppTimeline },

  data() {
    return {
      timelineItens: [
        {
          visibilidade: true,
          titulo: 'Perfil',
          textos: [
            'O Perfil é um banco de dados. Aqui, você poderá preencher informações referentes à sua '
              + 'formação acadêmica e perfil profissional, além de expressar seus interesses pessoais. Isso '
              + 'nos permitirá conhecer melhor todos os servidores da instituição, suas experiências e '
              + 'preferências de trabalho.',
          ],
          icone: 'person',
          link: '/perfil/cadastrar',
        },
      ],
    };
  },
};
</script>
